import { render, staticRenderFns } from "./title04-view.html?vue&type=template&id=a5f090b0&"
import script from "./title04-view.js?vue&type=script&lang=js&"
export * from "./title04-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports